import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useBasicSanitationChartsDataContext } from './hooks/useBasicSanitationChartsDataContext';

export const WaterSupplier = () => {
    const { chartData } = useBasicSanitationChartsDataContext();

    return (
        <SimpleBars
            title={'Abastecimento de Água'}
            horizontal={false}
            subtitles={chartData?.waterSupplier?.map((item) => item.description)}
            values={chartData?.waterSupplier?.map((item) => item.total  ||  0)}
        />
    );
};
